import React, { Fragment, useState } from "react";
import apiEndPoint from "../../../utils/apiEndPoint";
import { Navigate, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  loadFromLocalStorage,
  saveToLocalStorage,
} from "../../../utils/LocalStorageUtils";
import {
  apiCall,
  failedMessage,
  setDefaultHeader,
  successMessage,
} from "../../../utils/httpClient";
import { Button, Card, CloseButton, Container, Spinner } from "react-bootstrap";
import { CardBody, Modal, ModalHeader } from "reactstrap";
import { isEmpty } from "../../../utils/utils";
import LoginCover from '../logincover.png';
import "../auth.css";
import { FaApple, FaMobileAlt } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import GoolgeLoginModal from "../login/googleLogin";
import { BsMailbox2 } from "react-icons/bs";
import { useEffect } from "react";
import Header from "layout/header";
import Footer from "layout/footer";

function Signup() {
  const [signupPage, setSignupPage] = useState("email");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [varifyOtp, setVarifyOtp] = useState("");
  const [emailForget, setEmailForget] = useState("");
  const [password, setPassword] = useState("123456");
  const [errorMessage, setErrorMessage] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isGoogleLogin, setIsGoogleLogin] = useState(false);
  const navigate = useNavigate();
  const [languageData, setLanguageData] = useState(null);
    const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
    useEffect(() => {
      setLanguageData(selectLang?.language)
    }, [selectLang])
  const authData = loadFromLocalStorage("AUTH_DATA");
  if (authData?.token) {
    return <Navigate to="/" />;
  }
  const validation = () => {
    let isError = true;
    let errorMessage = {};
    if (signupPage === 'email') {
      if (email === undefined || email === "") {
        isError = false;
        errorMessage["email"] = "Please Enter Email ID";
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        isError = false;
        errorMessage["email"] = "Invalid email address";
      }
    }
    if (signupPage === 'mobile') {
      if (mobile === undefined || mobile === "") {
        isError = false;
        errorMessage["mobile"] = "Plese enter mobile";
      }
    }
    setErrorMessage(errorMessage);
    return isError;
  };

  const handleEmailSignup = async () => {

    if (validation()) {
      setLoading(true);

      let params = {};
      if (signupPage === 'email') {
        params['email'] = email
      }
      if (signupPage === 'mobile') {
        params['mobile'] = mobile
      }
      const { data } = await apiCall("post", apiEndPoint.CHECKMOBILEEMAILSIGNUP, params);
      if (data.status !== 200) {
        failedMessage(data.message);
      }
      if (data.status === 200) {
        successMessage(data.message);
        if (signupPage === 'mobile') {
          setShowOtpScreen(true)
        }
        // else {
        // if (data?.link != undefined && !isEmpty(data?.link))
        //   window.open(data.link);
        // }
        // setDefaultHeader("token", data.data.token);
        // saveToLocalStorage("AUTH_DATA", data.data);
        // navigate("/");
      }
      setLoading(false);
    }
  };

  const handleOtpVerify = async () => {
    if (varifyOtp != '') {
      setLoading(true);

      let params = {};
      if (signupPage === 'mobile') {
        params['mobile'] = mobile
        params['otp'] = varifyOtp
      }
      const { data } = await apiCall("post", apiEndPoint.LOGINOTPVERIFYMOBILE, params);
      if (data.status !== 200) {
        failedMessage(data.message);
      }
      if (data.status === 200) {
        successMessage(data.message);
        setShowOtpScreen(true)
        saveToLocalStorage("SIGNUPTOKEN", data.data?.token);
        saveToLocalStorage("SIGNUPMOBILE", mobile);
        navigate("/signupDetail");
      }
      setLoading(false);
    } else {
      setErrorMessage({ ...errorMessage, otp: 'Plese enter otp' });
    }
  };





  return (
    <Fragment>
            <Header />
      <Container>
        {isGoogleLogin &&
          <GoolgeLoginModal />
        }
        <section className="log-in-section">
          <div className="login-bg">
            {/* <div className="">
              <img
                src="/assets/images/fulllogo.png"
                alt="" width={200}
              />
            </div>
            <br /> */}
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-4 my-col-2">
                <div className="lt-text">
                  <h3>{languageData?.createanacc} </h3>
                  <p> {languageData?.getaccessto} 
                  </p>
                </div>
                <form>
                  <div className="form-group">
                    <div className="row">
                      {!showOtpScreen &&
                        <div className="col-lg-12 mt-adj">
                          {signupPage === 'email' &&
                            <div className="input-field-box">
                              <label>{languageData?.enterUrmail} </label>
                              <input
                                htmlFor="email"
                                value={email}
                                type="text"
                                size="large"
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={"example@yahoo.com"}
                                className={`${errorMessage.email ? "input-errmsg" : ""
                                  } form-control`}
                              />
                              {errorMessage.email && (
                                <span className="er-msg-show">
                                  {errorMessage.email}
                                </span>
                              )}
                            </div>
                          }
                          {signupPage === 'mobile' &&
                            <div className="input-field-box">
                              <label>Enter your Mobile</label>
                              <input
                                htmlFor="mobile"
                                value={mobile}
                                type="number"
                                size="large"
                                onChange={(e) => setMobile(e.target.value)}
                                placeholder={"e.g. 9000000009"}
                                className={`${errorMessage.mobile ? "input-errmsg" : ""
                                  } form-control`}
                              />
                              {errorMessage.mobile && (
                                <span className="er-msg-show">
                                  {errorMessage.mobile}
                                </span>
                              )}
                            </div>
                          }
                        </div>
                      }
                      {showOtpScreen && <div className="col-lg-12 mt-adj">
                        <div className="input-field-box">
                          <label>Enter your OTP</label>
                          <input
                            htmlFor="email"
                            value={varifyOtp}
                            type="number"
                            size="large"
                            onChange={(e) => setVarifyOtp(e.target.value)}
                            placeholder={"6 digit OTP"}
                            className={`${errorMessage.otp ? "input-errmsg" : ""
                              } form-control`}
                          />
                          {errorMessage.otp && (
                            <span className="er-msg-show">
                              {errorMessage.otp}
                            </span>
                          )}
                        </div>
                      </div>}
                    </div>
                    <br />
                    <div className="sav-btn mt-adj">
                      <button
                        type="button"
                        onClick={() => { showOtpScreen ? handleOtpVerify() : handleEmailSignup() }}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <Spinner animation="border" size="sm" role="status" />
                        ) : (
                          "Continue"
                        )}
                      </button>
                    </div>
                  </div>
                  <br />
                </form>
                <div style={{ position: 'relative' }}>
                  <p className="text-center" style={{ position: 'relative', top: '10px', zIndex: 1 }}>
                    <span style={{ background: '#fff', margin: '0', padding: '0 20px', }}>or</span>
                  </p>
                  <span style={{ margin: 0, borderTop: '1px solid #ddd', position: 'absolute', width: '100%', top: '20px', zIndex: 0 }} />
                </div> <br />
                {signupPage === 'email' && <Button
                  variant="outline-dark"
                  className="w-100 my-2"
                  style={{ borderRadius: "30px", fontSize: 14 }}
                  onClick={() => setSignupPage('mobile')}
                >
                  <FaMobileAlt className="me-2" />  {languageData?.loginmobi}
                </Button>
                }
                {signupPage === 'mobile' && <Button
                  variant="outline-dark"
                  className="w-100 my-2"
                  style={{ borderRadius: "30px", fontSize: 14 }}
                  onClick={() => setSignupPage('email')}
                >
                  <BsMailbox2 className="me-2" />  {languageData?.loginmail}
                </Button>
                }
                <Button
                  variant="outline-dark"
                  className="w-100 my-2"
                  style={{ borderRadius: "30px", fontSize: 14 }}
                  onClick={() => setIsGoogleLogin(true)}
                >
                  <FcGoogle className="me-2" /> {languageData?.logingoog}
                </Button>
                <Button
                  variant="outline-dark"
                  className="w-100 my-2"
                  style={{ borderRadius: "30px", fontSize: 14 }}
                >
                  <FaApple className="me-2" /> {languageData?.loginaple}
                </Button>
                <p className="pos-adj mt-4 text-center" style={{ color: '#444', fontWeight: 400 }}>
                  {languageData?.alreadyacc}
                  <a style={{ fontWeight: 600 }}
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    {languageData?.logIn}
                  </a>
                </p>
              </div>
              <div className="col-lg-8 my-col-1">
                <div className="text-center">
                  <img src={LoginCover} alt="login-vector"  className="login-vector" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </Container>
      <Footer/>
    </Fragment>
  );
}

export default Signup;